export interface ShouldIgnoreShortcutOptions {
  isShortcutsEnabled: boolean;
}

export function isVisibleDialog(el: Element): boolean {
  const style = window.getComputedStyle(el as HTMLElement);
  return (
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0'
  );
}

function hasVisibleDialog(): boolean {
  const dialogs = document.querySelectorAll('[role="dialog"]');
  return Array.from(dialogs).some(isVisibleDialog);
}

export function isEditableTarget(target: HTMLElement): boolean {
  const tagName = target.tagName.toLowerCase();
  return (
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select' ||
    target.contentEditable === 'true' ||
    target.isContentEditable
  );
}

export function shouldIgnoreShortcut(
  event: KeyboardEvent,
  options: ShouldIgnoreShortcutOptions,
): boolean {
  const { isShortcutsEnabled } = options;

  if (!isShortcutsEnabled) {
    return true;
  }

  if (event.ctrlKey || event.altKey || event.metaKey) {
    return true;
  }

  const target = event.target as HTMLElement;

  if (target.getAttribute('data-template-input') === 'true') {
    return true;
  }

  if (target.closest('[data-message-panel="true"]')) {
    return true;
  }

  if (isEditableTarget(target)) {
    return true;
  }

  if (hasVisibleDialog()) {
    return true;
  }

  return false;
}
